import { formatPhone } from "../../hooks/validation";
import { ColumnMeta } from "../CustomDatatable/CustomDatatable";
import { Company } from "../../store/types";
import {
  filterTextInput,
  textFilterTemplate,
  numberFilterTemplate,
  numberFilterMatchModeOptions,
  companyFilterTemplate,
  filterEqualsOption,
} from "./FilterTemplates";

export const phoneTemplate = (rowData: any) => {
  return formatPhone(rowData?.phone);
};

const companyName = {
  field: "name",
  header: "Компания",
  filter: true,
  filterField: "name",
  filterElement: companyFilterTemplate,
  filterMatchMode: "custom",
  filterFunction: filterEqualsOption,
  showFilterMatchModes: false,
};

const email = {
  field: "email",
  header: "Почта",
  filter: true,
  filterField: "email",
  filterElement: textFilterTemplate,
  filterFunction: filterTextInput,
  showFilterMatchModes: true,
};

const users = {
  field: "users",
  header: "Количество пользователей",
  dataType: "numeric",
  filter: true,
  filterField: "users",
  filterElement: numberFilterTemplate,
  showFilterMatchModes: true,
  filterMatchModeOptions: numberFilterMatchModeOptions,
};

const licenses = {
  field: "licenses",
  header: "Количество лицензий",
  dataType: "numeric",
  filter: true,
  filterField: "licenses",
  filterElement: numberFilterTemplate,
  showFilterMatchModes: true,
  filterMatchModeOptions: numberFilterMatchModeOptions,
};

const phone = {
  field: "phone",
  header: "Телефон",
  body: phoneTemplate,
  filter: true,
  filterField: "phone",
  filterElement: textFilterTemplate,
  filterMatchMode: "contains",
  showFilterMatchModes: true,
};

export const companyColumns: ColumnMeta<Company>[] = [
  companyName,
  users,
  licenses,
  phone,
  email,
];
